/*
  Marisa Profumerie - 30/09/2026
  Ricerca vuota: 4 prodotti scelti a caso, 2 tra i più venduti e 2 tra i nuovi arrivi
  (se una delle due liste è corta si completa con l'altra). I candidati arrivano da
  sections/search-popular-pool.liquid e restano in memoria per la sessione (30 minuti).
*/
(() => {
  const SLOTS = 4;
  const CACHE_KEY = 'marisa-search-popular-v2';
  const CACHE_MINUTES = 30;
  const sources = {
    best: '/collections/all?sort_by=best-selling&section_id=search-popular-pool',
    fresh: '/collections/all?sort_by=created-descending&section_id=search-popular-pool',
  };

  const readCache = () => {
    try {
      const data = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (data && Date.now() - data.time < CACHE_MINUTES * 60000) return data.pools;
    } catch (e) {}
    return null;
  };

  const writeCache = (pools) => {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ time: Date.now(), pools }));
    } catch (e) {}
  };

  const fetchPool = async (url) => {
    const response = await fetch(url, { credentials: 'same-origin' });
    if (!response.ok) throw new Error(response.status);
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const container = doc.querySelector('[data-popular-candidates]');
    return container ? [...container.children].map((el) => el.outerHTML) : [];
  };

  const loadPools = async () => {
    const cached = readCache();
    if (cached) return cached;
    const [best, fresh] = await Promise.all([fetchPool(sources.best), fetchPool(sources.fresh)]);
    const pools = { best, fresh };
    writeCache(pools);
    return pools;
  };

  const productKey = (html) => {
    const match = html.match(/href="([^"?#]*\/products\/[^"?#]+)/);
    return match ? match[1] : html;
  };

  const shuffle = (list) => {
    const a = list.slice();
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  };

  const pick = ({ best, fresh }) => {
    const chosen = [];
    const seen = new Set();
    const take = (list, count) => {
      for (const html of list) {
        if (chosen.length >= SLOTS || count <= 0) break;
        const key = productKey(html);
        if (seen.has(key)) continue;
        seen.add(key);
        chosen.push(html);
        count--;
      }
    };
    const b = shuffle(best);
    const f = shuffle(fresh);
    take(b, SLOTS / 2);
    take(f, SLOTS / 2);
    take(b, SLOTS);
    take(f, SLOTS);
    return shuffle(chosen);
  };

  const fill = (pools) => {
    document.querySelectorAll('[data-popular-pool]').forEach((block) => {
      const grid = block.querySelector('[data-popular-grid]');
      if (!grid) return;
      const chosen = pick(pools);
      if (!chosen.length) return;
      grid.innerHTML = chosen.join('');
      block.setAttribute('data-popular-ready', 'true');

      // Il tema ricorda il contenuto della ricerca vuota per quando si cancella il testo
      const search = block.closest('predictive-search-element');
      if (search && search.cached_results && search.results && !search.input?.value.trim()) {
        search.cached_results[''] = search.results.innerHTML;
      }
    });
    if (typeof window.trigger === 'function') {
      window.trigger('theme:search:reloaded');
      window.trigger('theme:transition:reload:search');
    }
  };

  const start = () => {
    if (!document.querySelector('[data-popular-pool]')) return;
    loadPools().then(fill).catch(() => {});
  };

  if ('requestIdleCallback' in window) {
    window.addEventListener('load', () => requestIdleCallback(start, { timeout: 3000 }));
  } else {
    window.addEventListener('load', () => setTimeout(start, 500));
  }
})();
